/**
 * Created with Mei Zhiwei on 2017-11-30 17:05:02.
 * Description: 基础信息
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-09-11 16:47:56
 */
import { statuses, bizTypes, accessTypes, barCodeTypes, appTypes, vendorTypes, postTypes, postStatuses, mappingChannels, bizTypeEnums, auditStatuses } from '@/config';
import { extract } from '@/lib/utils.js';
import _ from 'lodash';

const state = {
  statuses: [],
  bizTypes: [],
  accessTypes: [],
  appTypes: [],
  vendorTypes: [],
  mappingChannels: [],
  bizTypeEnums: [],
  postTypes: [],
  postStatuses: [],
  auditStatuses: [],
  barCodeTypes: []
}

// actions
const actions = {
  loadStatuses({ commit }) {
    if (_.isEmpty(state.statuses)) {
      let data = extract(statuses);
      commit('setStatuses', data)
    }
  },
  loadBizTypes({ commit }) {
    if (_.isEmpty(state.bizTypes)) {
      let data = extract(bizTypes);
      commit('setBizTypes', data)
    }
  },
  loadAccessTypes({ commit }) {
    if (_.isEmpty(state.accessTypes)) {
      let data = extract(accessTypes);
      commit('setAccessTypes', data)
    }
  },
  loadAppTypes({ commit }) {
    if (_.isEmpty(state.appTypes)) {
      let data = extract(appTypes);
      commit('setAppTypes', data)
    }
  },
  loadVendorTypes({ commit }) {
    if (_.isEmpty(state.vendorTypes)) {
      let data = extract(vendorTypes);
      commit('setVendorTypes', data)
    }
  },
  loadMappingChannels({ commit }) {
    if (_.isEmpty(state.mappingChannels)) {
      let data = extract(mappingChannels);
      commit('setMappingChannels', data)
    }
  },
  loadBizTypeEnums({ commit }) {
    if (_.isEmpty(state.bizTypeEnums)) {
      let data = extract(bizTypeEnums);
      commit('setBizTypeEnums', data)
    }
  },
  loadPostTypes({ commit }) {
    if (_.isEmpty(state.postTypes)) {
      let data = extract(postTypes, true);
      commit('setPostTypes', data);
    }
  },
  loadPostStatuses({ commit }) {
    if (_.isEmpty(state.postStatuses)) {
      let data = extract(postStatuses, true);
      commit('setPostStatuses', data);
    }
  },
  loadAuditStatuses({ commit }) {
    if (_.isEmpty(state.auditStatuses)) {
      let data = extract(auditStatuses, true);
      commit('setAuditStatuses', data);
    }
  },
  loadBarCodeTypes({ commit }) {
    if (_.isEmpty(state.barCodeTypes)) {
      let data = extract(barCodeTypes);
      commit('setBarCodeTypes', data)
    }
  }
};

// mutations
const mutations = {
  setStatuses(state, statuses) {
    state.statuses = statuses;
  },
  setBizTypes(state, types) {
    state.bizTypes = types;
  },
  setAccessTypes(state, types) {
    state.accessTypes = types;
  },
  setAppTypes(state, types) {
    state.appTypes = types;
  },
  setVendorTypes(state, types) {
    state.vendorTypes = types;
  },
  setMappingChannels(state, types) {
    state.mappingChannels = types;
  },
  setBizTypeEnums(state, types) {
    state.bizTypeEnums = types;
  },
  setPostTypes(state, types) {
    state.postTypes = types;
  },
  setPostStatuses(state, statuses) {
    state.postStatuses = statuses;
  },
  setAuditStatuses(state, statuses) {
    state.auditStatuses = statuses;
  },
  setBarCodeTypes(state, types) {
    state.barCodeTypes = types;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/constants.js